"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/ban-ts-comment */
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const shallow_1 = require("zustand/shallow");
const UsersAdminContext_1 = require("context/admin/UsersAdminContext");
const useSelectedUser_1 = require("context/useSelectedUser/useSelectedUser");
const useAddNewReviewees_1 = require("hooks/useAddNewReviewees/useAddNewReviewees");
const HelperUtils_1 = require("utils/HelperUtils");
const SelectMemberComponent_1 = __importDefault(require("components/SelectMemberComponents/SelectMemberComponent"));
const AddReviewee = react_1.default.memo(() => {
    const { id } = (0, react_router_1.useParams)();
    const { payloadBody, handleChangeState } = (0, useAddNewReviewees_1.useAddNewReviewees)((state) => ({
        payloadBody: state.payloadBody,
        handleChangeState: state.handleChangeState
    }), shallow_1.shallow);
    const { includes, excludes, selectAll } = payloadBody;
    const handleSetMember = ({ selectAll, include, exclude }) => {
        handleChangeState((draft) => {
            draft.payloadBody.includes = include;
            draft.payloadBody.excludes = exclude;
            draft.payloadBody.selectAll = selectAll;
        });
    };
    return (react_1.default.createElement("div", { className: "mb-[40px]" },
        react_1.default.createElement("p", { className: "typography-h500 text-n-900 mb-[4px]" }, (0, HelperUtils_1.getObjectiveLocale)('Add New Reviewees')),
        react_1.default.createElement("p", { className: "typography-h100 text-n-800 mb-[16px]" }, (0, HelperUtils_1.getObjectiveLocale)('Who would you like to have receive a review? ')),
        react_1.default.createElement(UsersAdminContext_1.UsersAdminProvider, null,
            react_1.default.createElement(useSelectedUser_1.SelectedUserProvider, { initialValue: {
                    include: includes === null || includes === void 0 ? void 0 : includes.map((id) => ({ id: id })),
                    exclude: excludes === null || excludes === void 0 ? void 0 : excludes.map((id) => ({ id: id })),
                    selectAll: selectAll
                } },
                react_1.default.createElement(SelectMemberComponent_1.default, { handleSet: handleSetMember, withJobPlacement: true, customClass: "pr-[24px]", metadataType: "totalAllPlacements", additionalParams: {
                        excludePlacementsCycleId: id
                    } })))));
});
AddReviewee.displayName = 'AddReviewee';
exports.default = AddReviewee;
